import { Navigate, useLocation } from 'react-router-dom';
import React from 'react';

interface IPrivateRouteProps {
  children: React.ReactNode;
  signInState: boolean;
}

const ProtectRoute = (props: IPrivateRouteProps) => {
  const { signInState, children } = props;
  const location = useLocation();

  if (!signInState) {
    // When not logged in, redirect to the login page and carry the current path as the return address
    return <Navigate to='/welcome' state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectRoute;
